export const timeKeyBangla = [
  "সেহরীর শেষ",
  "ফযর",
  "সূর্যোদয়",
  "যোহর",
  "আসর",
  "মাগরিব",
  "এশা",
];
